import React from 'react';
import '../../App.css';
import { Button } from '../Common/Button';
import '../Common/HeroSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faArrowDown} from '@fortawesome/free-solid-svg-icons';



function HeroSection() {
  
  return (
    <div className='hero-container'>
      <video src='./all_media_pages/Journey/videos/anonymous.mp4' autoPlay loop muted />
      <h1>My Journey</h1>
      <p className="center-text"><i>"Compare yourself to who you were yesterday, not to who someone else is today"</i></p>

      <div className='hero-btns'>


        <Button
          className='btns'
          buttonStyle='btn--primary'
          buttonSize='btn--large'
          onClick={() => window.open('https://drive.google.com/uc?export=download&id=1BeVLBx9-DH5TbUyfZDmULCL6FnC2rUCV', '_blank')}
        >
          Download my CV  <FontAwesomeIcon icon={faFilePdf} />
        </Button>

        <FontAwesomeIcon icon={faArrowDown} className='scroll-down-arrow' />

      </div>
    </div>
  );
}

export default HeroSection;
